/* import __COLOCATED_TEMPLATE__ from './team-assignment-limit.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isValidAssignmentLimit } from 'embercom/utils/team-assignment-limit-validation';

interface TeamSettings {
  assignmentLimit: number | null;
}

interface Signature {
  Element: HTMLDivElement;
  Args: {
    teamSettings: TeamSettings;
    onChange?: (value: number | null) => void;
  };
}

export default class TeamAssignmentLimit extends Component<Signature> {
  @tracked localAssignmentLimit: number | null = null;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.localAssignmentLimit = this.args.teamSettings.assignmentLimit;
  }

  get validAssignmentLimit() {
    return isValidAssignmentLimit(this.localAssignmentLimit);
  }

  @action
  updateAssignmentLimit(value: string) {
    if (value === '' || value === null) {
      this.localAssignmentLimit = null;
      this.args.onChange?.(null);
      return;
    }

    let numValue = parseInt(value, 10);

    if (isNaN(numValue)) {
      return;
    }

    this.localAssignmentLimit = numValue;
    this.args.onChange?.(numValue);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teams::TeamAssignmentLimit': typeof TeamAssignmentLimit;
    'settings/teams/team-assignment-limit': typeof TeamAssignmentLimit;
  }
}
